/**
 * @fileoverview Slider Update Implementation
 * @description Implements a utility for reinitializing sliders on various events
 *
 * Dependencies:
 * - subSliderInit function (external)
 * - sliderInit function (external)
 * - updatethumbnail function (external)
 *
 * Events Handled:
 * - shopify:section:load: Reinitializes sliders when Shopify section is loaded
 * - resize: Reinitializes sliders on window resize
 * - visibilitychange: Reinitializes sliders when page visibility changes
 */

(function () {
  /**
   * @function swiperInit
   * @description Reinitializes all slider components
   * @param {boolean} force - Whether to force reinitialization
   */
  function swiperInit() {
    subSliderInit(true);
    sliderInit(true);
    updatethumbnail(true);
  }

  // Initialize on various events
  document.addEventListener('shopify:section:load', function () {
    swiperInit();
  });

  document.addEventListener('resize', function () {
    swiperInit();
  });

  document.addEventListener('visibilitychange', function () {
    swiperInit();
  });

  // Initial initialization
  swiperInit();
})();
